module.exports = {
  none: 'none',
  xxs: '0 1px 2px rgba(0, 0, 0, 15%)',
  xs: '0 2px 6px rgba(0, 0, 0, 10%)',
  s: '0 2px 8px rgba(0, 0, 0, 15%)',
  m: '0 4px 12px rgba(0, 0, 0, 10%)',
  l: '0 6px 14px rgba(0, 0, 0, 16%)',
  xl: '0 6px 20px rgba(0, 0, 0, 33%)',
}
